import React from 'react'
import { useEffect, useState } from 'react'
import styles from "../../pages/graph/Graph.module.scss"
import publicRequest from 'services/publicRequest'
import SEARCH_ICON from "../../../assets/svg/Frame.svg"
import { ADD_STOCK, DOWNLOAD_STOCKS, SEARCH_STOCK } from 'services/apiEndpoints'
import SearchField from 'components/shared/searchfield/SearchField'
import { useDispatch, useSelector } from 'react-redux'
import { addStock, filtered, getStock, setModal } from 'redux/stockSlice'
import SearchModal from 'components/searchmodal/SearchModal'
import { useLocation } from 'react-router-dom'
import CROSS_ICON from "../../../assets/png/cross.png"
import privateRequest, { privateGet } from 'services/privateRequest'
import AVATAR from "../../../assets/png/profile.png"
import Button from 'components/shared/button/Button'
import toast from "components/shared/toast/toast";
import DOWNLOADING from "../../../assets/gif/download.gif"
import DOWNLOAD from "../../../assets/png/download.png"



const SearchBar = () => {
    const [search, setSearch] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false);
    const location = useLocation()
    const { name, modal } = useSelector((state) => state.stock)
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [term, setTerm] = useState('')
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    function handlechange(e) {
        e.stopPropagation()
        // dispatch(setModal(false))
        setTerm(e.target.value)
    }
    function handleclick() {
        dispatch(setModal(true))
        setShow(true)
    }
    function handleSubmit(e) {
        dispatch(addStock(e))
        setShow(false)
        setTerm("")
    }

    useEffect(() => {
        const call = async () => {
            try {
                let data = await privateRequest.get(`${SEARCH_STOCK}`, {
                    params: {
                        query: term
                    }
                })
                setSearch(data.data)
            } catch (err) {
                console.log(err)
            }
        }
        call()
    }, [debouncedSearchTerm])
    useEffect(() => {
        const debouncer = setTimeout(() => {
            setDebouncedSearchTerm(term)
        }, 1000);
        return () => {
            clearTimeout(debouncer)
        }
    }, [term])
    const isStockTrend = location.pathname.startsWith('/stocktrend');
    useEffect(() => {
        if (!modal) {
            setTerm('')
        }
    }, [modal])
    return (
        <>
            {/* {
                show ?
                    <div className={styles.modal}>
                        <div style={{ position: "relative" }}>
                            <SearchField placeholder="Search" onChange={handlechange} onClick={handleclick}
                                value={term}
                                modal={show}
                            />
                            <img src={SEARCH_ICON} className={styles.search_icon_abs} />
                            <img src={CROSS_ICON} className={styles.cancel} onClick={() => {
                                setShow(false)
                                setTerm("")
                            }} />

                        </div>

                    </div> :
                    <>
                        <div className={styles.top_search}>
                            <h3 className={styles.graph_page}>{isStockTrend && location.pathname == "/stocktrend" ? "Home" : name}</h3>

                            <div>
                                <div className={styles.search_container}>

                                    <SearchField placeholder="Search" onChange={handlechange} onClick={handleclick}
                                        modal={show}
                                        value={term}
                                    />
                                    <img src={SEARCH_ICON} className={styles.search_icon} />

                                </div>
                            </div>
                        </div>
                    </>

            } */}
            {/* <div className={show ? styles.modal : styles.top_search}>
                {!show && <h3 className={styles.graph_page}>{isStockTrend && location.pathname == "/stocktrend" || name == "" ? "Home" : name}</h3>
                }
                <div>
                    <div className={styles.search_container}>

                        <SearchField placeholder="Search" onChange={handlechange} onClick={handleclick}
                            modal={show}
                            value={term}
                        />
                        <img src={SEARCH_ICON} className={show ? styles.search_icon_abs : styles.search_icon} />
                        {
                            show && <img src={CROSS_ICON} className={styles.cancel} onClick={() => {
                                setShow(false)
                                setTerm("")
                            }} />
                        }


                    </div>
                </div>
            </div> */}
            <div className={styles.top_search}>
                {/* <Button label={isSubmitting ? <span>Downloading <i className="fa fa-refresh fa-spin mx-2"></i></span> : "Download"} onClick={handleClick}
                    disabled={isSubmitting} /> */}


                {<h3 className={styles.graph_page}>{isStockTrend && location.pathname == "/stocktrend" || name == "" ? "Home" : name}</h3>
                }

                <div>

                    <div className={styles.search_container}
                        onClick={(e) => e.stopPropagation()}>

                        <SearchField placeholder="Search" onChange={handlechange} onClick={handleclick}
                            value={term}
                        />
                        <img src={SEARCH_ICON} className={styles.search_icon} />
                        {term &&
                            <img src={CROSS_ICON} className={styles.cancel} onClick={() => {
                                setShow(false)
                                setTerm("")
                            }} />
                        }

                        {
                            term && modal && <SearchModal search={search} setShow={setShow} setTerm={setTerm} />
                        }
                    </div>

                </div>

                <div className={styles.username}>
                    <div className={styles.profile_img}>
                        <img src={AVATAR} style={{ width: "100%", height: "100%" }} /></div> {localStorage.getItem("username")}
                </div>

            </div>






        </>


    )
}

export default SearchBar

